module.exports = __webpack_public_path__ + "arrow-wrong.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/arrow-wrong.png
// module id = 519
// module chunks = 0